(() => {
  const activateLiquidacionTitle = () => {
    const titles = document.querySelectorAll('.text-block p, .text-block h1, .text-block h2');
    for (const title of titles) {
      const normalized = title.textContent.trim().replace(/\s+/g, ' ').toLocaleUpperCase('es-MX');
      if (normalized === 'JERSEYS EN LIQUIDACIÓN') {
        title.classList.add('goat-liquidacion-title');
        title.closest('.text-block')?.classList.add('goat-liquidacion-heading');
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activateLiquidacionTitle, { once: true });
  } else {
    activateLiquidacionTitle();
  }

  document.addEventListener('shopify:section:load', activateLiquidacionTitle);
})();